import styles from './Card.module.scss';
import { CardStack } from './CardStack';

export interface IOpponentCard {
  username: string;
  deckSize: number;
}

export interface IOpponentCardContainerProps {
  opponents: IOpponentCard[];
  lastCorrectPlayer?: string;
}

export function OpponentCardContainer(props: IOpponentCardContainerProps) {
  const { opponents, lastCorrectPlayer } = props;

  // TODO: Setup a timeout so that we can remove the last
  // correct player checkmark after a few seconds

  return (
    <div className={styles.opponentCardsContainer}>
      {opponents.map((opponent: IOpponentCard, index) => (
        <OpponentCard name={opponent.username} size={opponent.deckSize} isLastCorrectPlayer={opponent.username === lastCorrectPlayer} />
      ))}
    </div>
  );
}

interface IOpponentCardProps {
  name: string;
  size: number;
  isLastCorrectPlayer: boolean;
}

function OpponentCard(props: IOpponentCardProps) {
  const { name, isLastCorrectPlayer, size } = props;

  const cardStack = (
    <CardStack
      numOfPlayerCards={size}
      className={styles.opponentCard}
      isOpponentStack
    />
  );

  return (
    <div className={styles.opponentCardRoot}>
      {cardStack}
      <div className={`${styles.opponentCard} ${styles.opponentCardTop}`}>
        {isLastCorrectPlayer && <div className={styles.correctPlayer}>✔️</div>}
        {name}
      </div>
    </div>
  );
}